<template>
	<v-btn
		:block="block"
		:large="large"
        :depressed="depressed"
		:color="computedColors"
		:class="computedTextColor"
		:disabled="disabled"
		:loading="loading"
		@click="$emit('click')"
	>
		{{ computedLabelButton }}
		<v-icon right :size="computedSizeIcon">{{ computedIcon }}</v-icon>
	</v-btn>
</template>

<script>
export default {
	props: {
		block: {
			type: Boolean,
			default: false,
		},
		large: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		actividad: {
			type: Object,
			required: true,
		},
		mecanicoEstaAsignado: {
			type: Boolean,
			default: false,
		},
        depressed: {
            type: Boolean,
            default: false
        }
	},
	computed: {
		computedLabelButton() {
			return this.actividad.enCurso
				? this.mecanicoEstaAsignado
					? "En curso"
					: this.actividad.mecanicos.length == 0
						? "Reanudar"
						: "Unirse"
				: "Iniciar";
		},
		computedSizeIcon() {
			return this.actividad.enCurso
				? this.mecanicoEstaAsignado
					? "32"
					: this.actividad.mecanicos.length == 0
						? "28"
						: "28"
				: "26";
		},
		computedIcon() {
			return this.actividad.enCurso
				? this.mecanicoEstaAsignado
					? "mdi-progress-wrench"
					: this.actividad.mecanicos.length == 0
						? "mdi-fast-forward"
						: "mdi-account-plus"
				: "mdi-wrench";
		},
		computedColors() {
			return this.actividad.enCurso
				? this.mecanicoEstaAsignado
					? "amber"
					: this.actividad.mecanicos.length == 0
						? "teal"
						: "blue"
				: "green";
		},
		computedTextColor() {
			if (this.actividad.enCurso && this.mecanicoEstaAsignado) {
				return "black--text";
			}
			return "white--text";
		},
	},
};
</script>